import React from 'react';
import { FaShoppingCart, FaPhone, FaGooglePay, FaWhatsapp } from 'react-icons/fa';

const OrderSteps = () => {
  const steps = [
    {
      icon: <FaShoppingCart size={50} color="#fff" />,
      title: "Step 1",
      description: "Make an order",
      backgroundColor: '#d4a256',
    },
    {
      icon: <FaPhone size={50} color="#fff" />,
      title: "Step 2",
      description: "We will contact you.",
      backgroundColor: '#e94b4b',
    },
    {
      icon: <FaGooglePay size={50} color="#fff" />,
      title: "Step 3",
      description: "Make the payment",
      backgroundColor: '#007BFF',
    },
    {
      icon: <FaWhatsapp size={50} color="#fff" />,
      title: "Step 4",
      description: "Get video in 24 hours.",
      backgroundColor: '#4CAF50',
    },
  ];

  const sectionStyle = {
    padding: '3rem',
    backgroundColor: '#fdf2f2',
    borderRadius: '12px',
    boxShadow: '0px 6px 20px rgba(0, 0, 0, 0.1)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  };

  const headingStyle = {
    textAlign: 'center',
    fontSize: '2.5rem',
    color: '#e94b4b',
    marginBottom: '2rem',
    textTransform: 'uppercase',
    fontWeight: 'bold',
  };

  const stepsContainerStyle = {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'flex-start',
    width: '100%',
    flexWrap: 'wrap',
    gap: '2rem',
  };

  const stepStyle = {
    textAlign: 'center',
    fontSize: '1.2rem',
    color: '#333',
    margin: '1rem',
    padding: '2rem',
    borderRadius: '10px',
    backgroundColor: '#fff',
    boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.1)',
    transition: 'transform 0.2s, box-shadow 0.2s',
    flex: '1 1 200px', // Allow flexibility for smaller screens
    position: 'relative',
  };

  const handleHover = (e) => {
    e.target.style.transform = 'scale(1.05)';
    e.target.style.boxShadow = '0px 8px 20px rgba(0, 0, 0, 0.2)';
  };

  const handleLeave = (e) => {
    e.target.style.transform = 'scale(1)';
    e.target.style.boxShadow = '0px 4px 15px rgba(0, 0, 0, 0.1)';
  };

  return (
    <div style={sectionStyle}>
      <h2 style={headingStyle}>How to Order</h2>
      <div style={stepsContainerStyle}>
        {steps.map((step, index) => (
          <div
            key={index}
            style={{ ...stepStyle, backgroundColor: step.backgroundColor }}
            onMouseEnter={handleHover}
            onMouseLeave={handleLeave}
          >
            {step.icon}
            <h3 style={{ margin: '0.5rem 0', fontSize: '1.5rem', color: '#fff', fontWeight: 'bold' }}>{step.title}</h3>
            <p style={{ color: '#fff', margin: '0.5rem 0' }}>{step.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OrderSteps;
